import { Typography } from "@mui/material";

const DialoguePanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Dialogue settings.</Typography>;

export default DialoguePanel;
